import React from 'react'
import { FaTimes , FaBars } from 'react-icons/fa'
import { useState } from 'react';
import { Link } from 'react-scroll';

const NavBar = () => {

    const [nav, setNav] =  useState(false);

    const links = [
        {
            id: 1,
            link: 'home',
        },
        {
            id: 2,
            link: 'about',
        },
        {
            id: 3,
            link: 'portfolio',
        },
        {
            id: 4,
            link: 'experience',
        },
        {
            id: 5,
            link: 'contact',
        },
    ]
  return (
    <div className='flex justify-between items-center w-full h-20 px-4 text-white fixed bg-black'>
        <div>
            <h1 className='text-5xl font-signature ml-2'><Link to="home" smooth duration={500}>Pritham B G</Link></h1>
        </div>

        <ul className='hidden md:flex'>
            {
                links.map(({id , link} , index)=>{
                    return <li className='px-4 cursor-pointer capitalize font-medium text-gray-500 hover:scale-105 duration-200 text-2xl hover:text-white' key={id}>
                            <Link to={link} smooth duration={500}>
                                {link}
                            </Link>
                        </li>
                })
            }
        </ul>
        <div onClick={() => setNav(!nav)} className='cursor-pointer pr-4 z-20 text-gray-500 md:hidden'>
            {
                nav ? <FaTimes size={30}/> : <FaBars size={30}/>
            }
        </div>

        {/* This is for the small devices */}

        {
            nav && (
                <ul className='flex flex-col justify-center items-center absolute top-0 left-0 w-screen h-screen bg-gradient-to-b from-black to-gray-800 text-gray-500 z-2'>
            {
                links.map(({id , link} , index)=>{
                    return <li className='px-4 capitalize cursor-pointer py-6 text-4xl' key={id}>
                        <Link to={link} smooth duration={500} onClick={()=> setNav(!nav)}>
                        {link}
                        </Link>
                    </li>
                })
            }
        </ul>
            )
        }
        
        
    </div>
  )
}

export default NavBar